
import {map} from 'rxjs/operators';
import {EventEmitter, Injectable} from '@angular/core';
import {StorageService} from '../../storage/storage.service';
import {HttpService} from '../http-service.service';
import {ApiConst} from '../api-const';
import {Observable} from 'rxjs';
import {Spool} from '../../../model/spool';
import {AuthenticationService} from '../security/authentication.service';

/**
 * Service that handle the list of acceptables files per kind for upload
 */
@Injectable()
export class KindOfAcceptedFilesService {
  /**
   * file extensions for PRINCIPAL
   */
  public PRINCIPAL_FILE_EXTENSIONS: string[];

  /**
   * file extensions for PRINCIPAL
   */
  public ANNEX_FILE_EXTENSIONS: string[];

  /**
   * file extensions for DATA
   */
  public DATA_FILE_EXTENSIONS: string[];

  /**
   * file extensions for SPOOL
   */
  public SPOOL_FILE_EXTENSIONS: string[];
  /**
   * instantiate variables
   * @param {StorageService} storageService - handle retrieving info if they exists inside storage
   */
  constructor(private storageService: StorageService, private httpService: HttpService, private authService: AuthenticationService) {
    this.PRINCIPAL_FILE_EXTENSIONS = [];
    this.ANNEX_FILE_EXTENSIONS = [];
    this.DATA_FILE_EXTENSIONS = [];
    this.SPOOL_FILE_EXTENSIONS = [];
    this.init();
  }

  /**
   * retrieving info from storage if  they exists
   */
  private init(): void {
    const acceptedExtensions = this.storageService.getAcceptedFilesFromStorage();
    if (acceptedExtensions) {
      this.PRINCIPAL_FILE_EXTENSIONS = acceptedExtensions.listExtensionsPrincipalDocument;
      this.ANNEX_FILE_EXTENSIONS = acceptedExtensions.listExtensionsAnnexeDocument;
      this.DATA_FILE_EXTENSIONS = acceptedExtensions.listExtensionsDataDocument;
      this.SPOOL_FILE_EXTENSIONS = acceptedExtensions.listExtensionsSpoolDocument;
    }
    this.authService.documentExtData.subscribe(data => {
      if (data) {
        this.buildExtensionsLists(data);
      }
    });
  }

  /**
   * Determine if a file extension is include inside PRINCIPAL_FILE_EXTENSIONS
   *
   * @param {string} extension - the file extension to test
   * @return {boolean} true if the extension in included in PRINCIPAL_FILE_EXTENSIONS
   */
  public isPrincipal(extension: string): boolean {
    return this.PRINCIPAL_FILE_EXTENSIONS.indexOf(extension) >= 0;
  }

  /**
   * Determine if a file extension is include inside ANNEX_FILE_EXTENSIONS
   *
   * @param {string} extension - the file extension to test
   * @return {boolean} true if the extension in included in ANNEX_FILE_EXTENSIONS
   */
  public isAnnex(extension: string): boolean {
    return this.ANNEX_FILE_EXTENSIONS.indexOf(extension) >= 0;
  }

  /**
   * Determine if a file extension is include inside DATA_FILE_EXTENSIONS
   *
   * @param {string} extension - the file extension to test
   * @return {boolean} true if the extension in included in DATA_FILE_EXTENSIONS
   */
  public isData(extension: string): boolean {
    return this.DATA_FILE_EXTENSIONS.indexOf(extension) >= 0;
  }

  /**
   * Determine if a file extension is include inside SPOOL_FILE_EXTENSIONS
   *
   * @param {string} extension - the file extension to test
   * @return {boolean} true if the extension in included in SPOOL_FILE_EXTENSIONS
   */
  public isSpool(extension: string): boolean {
    return this.SPOOL_FILE_EXTENSIONS.indexOf(extension) >= 0;
  }

  public buildExtensionsLists(acceptedExtensions: any): void {
    this.PRINCIPAL_FILE_EXTENSIONS = acceptedExtensions.listExtensionsPrincipalDocument;
    this.ANNEX_FILE_EXTENSIONS = acceptedExtensions.listExtensionsAnnexeDocument;
    this.DATA_FILE_EXTENSIONS = acceptedExtensions.listExtensionsDataDocument;
    this.SPOOL_FILE_EXTENSIONS = acceptedExtensions.listExtensionsSpoolDocument;

    const filterForStorage = {
      listExtensionsPrincipalDocument: this.PRINCIPAL_FILE_EXTENSIONS,
      listExtensionsAnnexeDocument: this.ANNEX_FILE_EXTENSIONS,
      listExtensionsDataDocument: this.DATA_FILE_EXTENSIONS,
      listExtensionsSpoolDocument: this.SPOOL_FILE_EXTENSIONS
    };
    this.storageService.addAcceptedFilesInStorage(filterForStorage);
  }

  public getCustomerSpoolList(): Observable<Spool[]> {
      return this.httpService.$post(ApiConst.getCustomerSpoolList, '').pipe(map(response => {
        return response.body.datas.spools;
      }));
  }
}
